/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObjectUtils from './MoserObjectUtils';
import MoserObject from './MoserObject';
import InstanceType from './InstanceType';
import FilterUsageType from './FilterUsageType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // updateShortcutSet
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/FilterUsageType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="postAutoAggregation" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="filterUsage" type="{}filterUsageType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Filter extends ObjectType{

	expression = null;

	postAutoAggregation = null;

	ref = null;

	instanceType = null;

	filterUsage = null;

	_referencedObject = null;



	/**
	 * Gets the value of the expression property.
	 * @return {String} possible object is {@link String}
	 */
	getExpression() {
		return this.expression;
	}

	/**
	 * Sets the value of the expression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpression(value) {
		var oldValue = this.expression;
		this.expression = value;
		this._setAndNotify(5, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 5, oldValue, value);
	}

	/**
	 * Gets the value of the postAutoAggregation property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isPostAutoAggregation() {
		return this.postAutoAggregation;
	}

	/**
	 * Sets the value of the postAutoAggregation property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setPostAutoAggregation(value) {
		var oldValue = this.postAutoAggregation;
		this.postAutoAggregation = value;
		this._setAndNotify(166, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 166, oldValue, value);
	}

	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(6, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 6, oldValue, value);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the instanceType property.
	 * @return {InstanceType} possible object is {@link InstanceType}
	 */
	getInstanceType() {
		return this.instanceType;
	}

	/**
	 * Sets the value of the instanceType property.
	 * @param {InstanceType} value allowed object is {@link InstanceType}
	 */
	setInstanceType(value) {
		var oldValue = this.instanceType;
		this.instanceType = value;
		this._setAndNotify(9, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 9, oldValue, value);
	}

	/**
	 * Gets the value of the filterUsage property.
	 * @return {FilterUsageType} possible object is {@link FilterUsageType}
	 */
	getFilterUsage() {
		return this.filterUsage;
	}

	/**
	 * Sets the value of the filterUsage property.
	 * @param {FilterUsageType} value allowed object is {@link FilterUsageType}
	 */
	setFilterUsage(value) {
		var oldValue = this.filterUsage;
		this.filterUsage = value;
		this._setAndNotify(296, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutSet(this, 296, oldValue, value);
	}

	/**
	 * Creates a new instance of <code>Filter</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Filter</code> object from.
	 * @return {Filter} an object of type <code>Filter</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createFilter();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Filter";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 5, "expression", null));
		featureList.push(this.createFeature(false, false, false, 166, "postAutoAggregation", null));
		featureList.push(this.createFeature(false, false, false, 6, "ref", null));
		featureList.push(this.createFeature(false, true, false, 9, "instanceType", InstanceType));
		featureList.push(this.createFeature(false, true, false, 296, "filterUsage", FilterUsageType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 5:
			this.setExpression((value));
			break;
		case 166:
			this.setPostAutoAggregation((value));
			break;
		case 6:
			this.setRef((value));
			break;
		case 9:
			this.setInstanceType((value));
			break;
		case 296:
			this.setFilterUsage((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 5:
			return this.getExpression();
		case 166:
			return this.isPostAutoAggregation();
		case 6:
			return this.getRef();
		case 9:
			return this.getInstanceType();
		case 296:
			return this.getFilterUsage();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 5:
			return this.getExpression();
		case 166:
			return this.isPostAutoAggregation();
		case 6:
			return this.getRef();
		case 9:
			return this.getInstanceType();
		case 296:
			return this.getFilterUsage();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/Filter.js